import { FetchFundingSettings } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { PaymentState } from './types'
import { PartnerPaymentProvider } from 'src/interfaces/payment'
import { isSandbox } from 'src/utils/env'

const getInitialState = (): PaymentState => ({
  paymentProvider: null,
  showSandboxUsBankBanner: false,
})

export const paymentReducer = (
  state: PaymentState = getInitialState(),
  action: Action<any>,
): PaymentState => {
  switch (action.type) {
    case FetchFundingSettings.type.SUCCESS: {
      return {
        ...state,
        paymentProvider: action.payload.paymentProvider,
        showSandboxUsBankBanner:
          isSandbox() && action.payload.paymentProvider === PartnerPaymentProvider.UsBank,
      }
    }
    default:
      return state
  }
}
